// Stage 1 "Silent defaults" · group G5 (controls / risks / sampling) — screen strings, EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_SD_G5 = {
  en: {
    sd: {
      notRecorded: "Not recorded",                       // A-24: a control attribute nobody entered (M/A, P/D, frequency)
      selectSeverity: "Select severity",                 // A-25: the deficiency severity placeholder
      deficiencySeverityRequired: "Choose the deficiency's severity (deficiency or significant) before saving.",
      notAssessed: "Not assessed",                       // A-26: a risk rating nobody entered
      ratingsRequired: "Rate the risk before saving: inherent risk, control risk, likelihood, impact and overall rating.",
      setPmOmInMateriality: "Set materiality in 105(a)",   // A-22: PM / OM not set → no scoping suggestion (rule S9)
      scopingGuardOmNotSet: "Overall materiality not set in 105(a) — analytical review only is not available until it is set.",
      differenceUnrated: "Not rated — set clearly trivial in 105(a)",   // A-33: a vouching difference with no CT to compare with
      noTargetDate: "No target date",                     // A-29: ISQM remediations without a target date
    },
  },
  ar: {
    sd: {
      notRecorded: "غير مسجَّل",
      selectSeverity: "اختر درجة الخطورة",
      deficiencySeverityRequired: "اختر درجة خطورة القصور (قصور أو قصور جوهري) قبل الحفظ.",
      notAssessed: "لم يُقيَّم",
      ratingsRequired: "قيِّم الخطر قبل الحفظ: الخطر الملازم، وخطر الرقابة، والاحتمال، والأثر، والتقييم الإجمالي.",
      setPmOmInMateriality: "حدِّد الأهمية النسبية في 105(a)",
      scopingGuardOmNotSet: "الأهمية النسبية الإجمالية غير محددة في 105(a) — المراجعة التحليلية فقط غير متاحة حتى تحديدها.",
      differenceUnrated: "غير مُقيَّم — حدِّد الحد التافه بوضوح في 105(a)",
      noTargetDate: "بلا تاريخ مستهدف",
    },
  },
};

export default I18N_SD_G5;
